import React from 'react';
import { cn } from '@/lib/utils';

export function AnimatedBackground({ children, className = "" }) {
  return (
    <div className={cn("relative isolate overflow-hidden", className)}>
      {/* Atmospheric gradient layers */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 -z-10 bg-[radial-gradient(circle_at_top,_rgba(255,255,255,0.85),_transparent_55%)]"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 -z-20 bg-[linear-gradient(135deg,_rgba(255,255,255,0.65)_0%,_rgba(212,224,222,0.35)_100%)]"
      />
      {/* Subtle accent gradient orbs */}
      <div
        aria-hidden="true"
        className="pointer-events-none absolute right-0 top-20 -z-15 h-[500px] w-[500px] rounded-full bg-[radial-gradient(circle,_rgba(31,76,84,0.08)_0%,_transparent_70%)] blur-3xl"
      />
      <div
        aria-hidden="true"
        className="pointer-events-none absolute bottom-40 left-10 -z-15 h-[400px] w-[400px] rounded-full bg-[radial-gradient(circle,_rgba(212,224,222,0.15)_0%,_transparent_70%)] blur-3xl"
      />
      {children}
    </div>
  );
}

export function GradientBorder({ children, className = "" }) {
  return (
    <div
      className={cn(
        "relative rounded-2xl border border-[rgba(31,76,84,0.12)] bg-white/70 p-0.5 shadow-[0_18px_32px_rgba(15,23,42,0.08)] backdrop-blur-md",
        className
      )}
    >
      <div className="rounded-[1rem] bg-white p-6 shadow-[inset_0_1px_0_rgba(255,255,255,0.65)]">
        {children}
      </div>
    </div>
  );
}
